// extracted by mini-css-extract-plugin
export default {"bigInput":"BigInputField_bigInput__KY54C"};